import { Box, Button } from '@mui/material';
import _ from 'lodash';
import { Control } from 'react-hook-form';
import { useMemo } from 'react';
import DataTable from 'components/common/data-table';
import { useLocation } from 'react-router-dom';
import TooltipIconButton from 'components/common/tooltip-icon-button';
import getIcon from 'icons/icons';
import { ADD, DELETE } from 'icons/icon-names';
import { useTheme } from '@mui/styles';
import { useCallback } from 'react';
import { formatGridNumber } from 'utils/common-utils';
import { NumericEditor } from 'components/common/data-table/numericEditor';
interface IProps {
  control: Control<any>;
  setValue?: any;
  watchAllFields?: any;
  getValues?: any;
}

export default function AnalysisOfBalanceSheet({ control, setValue, watchAllFields, getValues }: IProps) {
  const { state } = useLocation();
  const theme = useTheme();

  const colDefs = useMemo(() => {
    var colDef: any = [
      {
        field: 'natureOfLiability',
        headerName: 'Nature of Liability',
        editable: state.viewOnly ? false : true,
        width: 150,
      },
      {
        field: 'amount',
        headerName: 'Amount',
        valueFormatter: formatGridNumber,
        cellEditor: NumericEditor,
        cellStyle: { textAlign: 'right' },
        editable: state.viewOnly ? false : true,
        width: 150,
      },
      {
        field: 'netWorthPercentage',
        headerName: '% of Net worth',
        editable: state.viewOnly ? false : true,
        width: 150,
      },
      {
        field: 'comments',
        headerName: 'Comments',
        editable: state.viewOnly ? false : true,
        width: 150,
      },
    ];
    if (!state.viewOnly) {
      colDef.push({
        field: '',
        headerName: 'Actions',
        width: 100,
        pinned: 'right',
        suppressSizeToFit: true,
        cellRendererFramework: (params: any) => {
          return (
            <>
              {params.rowIndex === getValues('analysisOffBalanceSheet.liabilityItems').length - 1 && (
                <TooltipIconButton
                  onClick={() => {
                    params.api.stopEditing();
                    setTimeout(() => {
                      let fields = [...getValues('analysisOffBalanceSheet.liabilityItems'), {}];
                      setValue('analysisOffBalanceSheet.liabilityItems', fields);
                      params.api.setRowData(fields);
                    }, 100);
                  }}
                  icon={getIcon(ADD, theme.palette.primary.main)}
                  title="Add"
                />
              )}
              {getValues('analysisOffBalanceSheet.liabilityItems').length > 1 && (
                <TooltipIconButton
                  onClick={(e: any) => {
                    let updatedFields = [...getValues('analysisOffBalanceSheet.liabilityItems')];
                    if (updatedFields.length > 0) {
                      updatedFields.splice(params.node.rowIndex, 1);
                      setValue('analysisOffBalanceSheet.liabilityItems', updatedFields);
                      params.api.setRowData(updatedFields);
                    }
                  }}
                  icon={getIcon(DELETE, theme.palette.error.main)}
                  title="Delete"
                />
              )}
            </>
          );
        },
      });
    }
    return colDef;
  }, []);

  const onCellValueChanged = useCallback((event) => {
    let updatedRowData: any = [];
    event.api.forEachNode((e: any) => {
      updatedRowData.push(e.data);
    });
    setValue('analysisOffBalanceSheet.liabilityItems', updatedRowData);
  }, []);

  return (
    <Box sx={{ mb: 7 }}>
      <Box sx={{ mt: 1 }}>
        <DataTable
          columnDefs={colDefs}
          autoSize={true}
          rowData={watchAllFields?.analysisOffBalanceSheet?.liabilityItems}
          pagination={false}
          domLayout={'autoHeight'}
          sizeToFit={true}
          style={{ height: '100%' }}
          onCellValueChanged={onCellValueChanged}
        />
      </Box>
    </Box>
  );
}
